import getConfig from 'next/config';

import { getNavLinkProps } from '../../helpers/getPageProps';

/**
 * Generates footer properties for the landing page.
 *
 * @param {CareerSiteApiProps} siteContent - The global site content data.
 * @param {import("react-intl").IntlShape} intl - The internationalization object for formatting messages.
 * @returns {Object} An object containing footer properties, including links, copyright information, and edit mode options.
 */
export const getFooterProps = (siteContent, intl) => {
  const { publicRuntimeConfig } = getConfig();
  return {
    links:
      siteContent.secondaryLinks?.map((link) => getNavLinkProps(link)) || [],
    copyright: {
      text: intl.formatMessage({
        id: 'landingpage.copytext',
      }),
      href: '/',
    },
    editMode:
      'editModeLink' in siteContent && siteContent.editModeLink
        ? {
            text: siteContent.editModeLink.text || 'Edit FOOTER',
            link: publicRuntimeConfig.cmsBaseUrl + siteContent.editModeLink.url,
          }
        : undefined,
  };
};

/**
 * Retrieves social media channel links from the site content.
 *
 * @param {CareerSiteApiProps} siteContent - The global site content data.
 * @returns {Object} An object containing social media channel links.
 */
export const getSocialMediaChannels = (siteContent) => ({
  channels: siteContent.socialMedia?.links || [],
});
